import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function BlogPage() {
  const [blogs, setBlogs] = useState([]);
  useEffect(() => { api.get("/blogs").then(({ data }) => setBlogs(data)); }, []);

  return (
    <div className="pt-12 pb-24">
      <div className="container-eq">
        <div className="max-w-3xl">
          <div className="label-eq text-sky-500 mb-3">Blog</div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tighter" data-testid="blog-title">Latest insights</h1>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {blogs.map((b) => (
            <Link to={`/blog/${b.slug}`} key={b.id} className="card-eq overflow-hidden group" data-testid={`blog-card-${b.slug}`}>
              <div className="aspect-[16/10] bg-neutral-100 overflow-hidden">
                {b.featured_image && <img src={b.featured_image} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
              </div>
              <div className="p-6">
                <div className="text-xs uppercase tracking-widest text-sky-500 font-semibold">{b.category}</div>
                <h3 className="font-display font-bold text-lg mt-2 leading-tight">{b.title}</h3>
                <p className="text-sm text-neutral-600 mt-2 line-clamp-3">{b.excerpt}</p>
                <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold group-hover:text-sky-500 transition-colors">
                  Read more <ArrowRight className="w-3.5 h-3.5" />
                </div>
              </div>
            </Link>
          ))}
        </div>
        {blogs.length === 0 && <div className="text-center text-neutral-500 py-16">No articles yet. Check back soon.</div>}
      </div>
    </div>
  );
}
